import { inject, provide } from '@vue/composition-api'

let i = 0

export function defineProvider<T>() {
  const key = `__provider__${i++}`
  return {
    provide(value: T) {
      return provide(key, value)
    },
    inject(): T {
      return inject<T>(key) as any
    },
  }
}
